"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditBuilderMockStates = void 0;
var CreditBuilderMockStates;
(function (CreditBuilderMockStates) {
    // Credit scores
    CreditBuilderMockStates["POOR_CREDIT_SCORE"] = "poorCreditScore";
    CreditBuilderMockStates["FAIR_CREDIT_SCORE"] = "fairCreditScore";
    CreditBuilderMockStates["GOOD_CREDIT_SCORE"] = "goodCreditScore";
    CreditBuilderMockStates["VERY_GOOD_CREDIT_SCORE"] = "veryGoodCreditScore";
    CreditBuilderMockStates["EXCELLENT_CREDIT_SCORE"] = "excellentCreditScore";
    CreditBuilderMockStates["NO_CHANGE_CREDIT"] = "noChangeCredit";
    CreditBuilderMockStates["DECREASE_CREDIT"] = "decreaseCredit";
    // Error states
    CreditBuilderMockStates["FROZEN_CREDIT"] = "frozenCredit";
    CreditBuilderMockStates["INSUFFICIENT_HISTORY_CREDIT"] = "insufficientHistoryCredit";
    CreditBuilderMockStates["NO_MATCH_CREDIT"] = "noMatchCredit";
    CreditBuilderMockStates["NO_UPDATE_CREDIT"] = "noUpdateCredit";
    // Flex history
    CreditBuilderMockStates["EMPTY_FLEX_HISTORY"] = "emptyFlexHistory";
    CreditBuilderMockStates["ONE_MONTH_FLEX_HISTORY"] = "oneMonthFlexHistory";
    CreditBuilderMockStates["FIVE_MONTH_FLEX_HISTORY"] = "fiveMonthFlexHistory";
})(CreditBuilderMockStates || (exports.CreditBuilderMockStates = CreditBuilderMockStates = {}));
